import {datadogRum} from '@datadog/browser-rum';
import {SkillzAPIError} from '@/utils/customErrors';

const reportErrorCodes = [
  500, // internal server error
  502, // bad gateway
  503, // service unavailable
  504, // gateway timeout
  429, // too many requests
];

export function handleError(res: Response, url: string, options?: RequestInit): void {
  // Here we can handle different types of general errors
  console.log(`Error occurred while fetching data from ${url}`, options, res); //Fix build errors

  if (reportErrorCodes.includes(res.status)) {
    datadogRum.addError(
      new SkillzAPIError(`NetClient request for ${url} failed with ${res.status}`),
      {
        source: 'handleError',
        context: {
          res,
          options,
        },
      }
    );
  }
}
